import { useState, useRef, useEffect } from 'react';
import logoImage from '../../../assets/clodexa-logo.png';
import { FaChevronDown } from "react-icons/fa6";
import { LogoDropdown } from './LogoDropdown';

interface LogoProps {
  isOpen: boolean;
}

export const Logo: React.FC<LogoProps> = ({ isOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={menuRef} className={`flex items-center ${isOpen ? 'justify-start' : 'justify-center'} h-full w-full relative`}>
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className={`flex items-center ${isOpen ? 'px-[16px]' : 'w-full justify-center'} cursor-pointer`}
      >
        <img 
          src={logoImage} 
          alt="Clodexa Logo"
          className="w-[24px] h-[24px] rounded-[4px]"
        />
        {isOpen && (
          <span className="flex items-center text-[16px] justify-center ml-[8px] text-[#000000] font-medium leading-[var(--lineheight20)] tracking-[var(--letterspacing-032)] text-left underline-offset-[from-font] decoration-skip-ink-none">
            Clodexa
            <FaChevronDown className="ml-[4px] text-[#000000] text-[12px]"/>
          </span>
        )}
      </div>

      <LogoDropdown isOpen={isMenuOpen && isOpen} onClose={() => setIsMenuOpen(false)} />
    </div>
  );
}; 